// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { mergeTransactionData, setApiTimestamp, setTransactionData } from "_core/slices/datas/TransactionSlice";

const AdminUserEditApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/user_edit";

    // API実行
    const ExecAdminUserEditApi = async (requestParams) => {
        // 必要なリクエストを定義

        let response = null;
        let error = null;

        // console.log(url + "API開始");
        try {
            response = await ApiRequest({ url, requestParams});
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
            dispatch(setTransactionData({
                tUser:response['t_user'],
                tUserAdd:response['t_user_add'],
                tAccount:response['t_account']
            }));

            if (response['t_asset_list'])
            {
                dispatch(mergeTransactionData({
                    tAssetList:response['t_asset_list']
                }));
            }
        }
        return { response, error };
    };

    return ExecAdminUserEditApi;
};

export default AdminUserEditApi;